// extracted by mini-css-extract-plugin
module.exports = {"wraper":"TheRegistration_wraper_NF61c"};